import React, { FC, useState } from "react";
import { useParams } from "@Libs/Router/hooks/useParams";
import { IAppRoute } from "@App/types";
import {
  Subscribe,
  SubscribeSuccessPayload,
} from "@modules/Subscriptions/Flows/Subscribe/Subscribe";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { ConfirmationModal } from "@modules/Subscriptions/Components/ConfirmationModal/ConfirmationModal";

export const BASE_SUBSCRIPTION_FLOW_ROUTE: IAppRoute[] = [
  "SERVICE_OFFERS",
  "SERVICE_OFFER",
  "CLOSE",
];

export const ServiceOfferClosureSubscriptionFlow: FC = () => {
  const { serviceOfferId } = useParams(BASE_SUBSCRIPTION_FLOW_ROUTE);
  const navigate = useNavigate();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [subscribeSuccessPayload, setSubscribeSuccessPayload] =
    useState<SubscribeSuccessPayload>(null);

  const handleSubscribeSuccess = async (
    subscribeSuccessPayload: SubscribeSuccessPayload
  ) => {
    setSubscribeSuccessPayload(subscribeSuccessPayload);
    setIsSuccessModalOpen(true);
  };

  return (
    <>
      <Subscribe
        onSuccess={handleSubscribeSuccess}
        onLeave={() =>
          navigate([...BASE_SUBSCRIPTION_FLOW_ROUTE, "CHECKOUT"], {
            params: { serviceOfferId },
          })
        }
        rootRoute={{
          to: [...BASE_SUBSCRIPTION_FLOW_ROUTE, "CHECKOUT", "SUBSCRIBE"],
          params: { serviceOfferId },
        }}
        backRoute={{
          to: BASE_SUBSCRIPTION_FLOW_ROUTE,
          params: { serviceOfferId },
        }}
        state={{
          relatedServiceId: Number(serviceOfferId),
        }}
      />
      <ConfirmationModal
        isOpen={isSuccessModalOpen}
        onConfirm={() =>
          navigate(BASE_SUBSCRIPTION_FLOW_ROUTE, {
            params: { serviceOfferId },
          })
        }
        paymentMethod={subscribeSuccessPayload?.paymentMethod}
        isPaymentConfirmed={subscribeSuccessPayload?.isPaymentConfirmed}
      />
    </>
  );
};
